import { render } from "./TopTwo.vue?vue&type=template&id=333abd7f&scoped=true&ts=true"
import script from "./TopTwo.vue?vue&type=script&lang=ts"
export * from "./TopTwo.vue?vue&type=script&lang=ts"

import "./TopTwo.vue?vue&type=style&index=0&id=333abd7f&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-333abd7f"]])

export default __exports__